<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { mapState } from "vuex"
import { PopupLoading } from "./components/popup"
import { vConsoleWidget } from "@/utils/index"
export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(["loading"])
  },
  mounted() {
    this.loadvConsoleWidget(this.$route)
  },
  methods: {
    /**
     * 加载vConsole小部件
     */
    loadvConsoleWidget(route = {}) {
      const { vc } = route.query
      if (vc === "true") vConsoleWidget()
    }
  }
}
</script>

<style lang="less">
@import "./assets/css/public.less";
@mainColor: #88B539;
body {
  background: #fff;
  padding: 0;
  margin: 0;
  height: 100vh;
  color: #000;
}
#app {
  font-size: 28px;
}
.btn {
  height: 106px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1C1C1A;
  background: @mainColor;
  font-size: 32px;
  font-weight: 600;
  // border-radius: 14px;
  border: none;
}
.downloadAppBox {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 2px 10px #636363;
  z-index: 1;
  &-cancel {
    padding: 20px;
    display: flex;
    align-items: center;

    img {
      width: 100%;
      margin: 0 20px;
      border-radius: 10px;
    }
  }
  &-btn {
    padding: 0 20px;
    margin-right: 20px;
  }
}
</style>
